import React from 'react';

import './LoadingComponent.scss';

export const LoadingComponent = () => (
    <div className="loader flex-container flex-center">
        <div className="loader-inner" />
    </div>
);



// WEBPACK FOOTER //
// ./src/components/loading/LoadingComponent.js